<script setup lang="ts">
import { Edit3, Plus, X, MoreVertical, Check, ChevronDown } from 'lucide-vue-next';

defineProps<{
  isHeaderMenuOpen?: boolean;
  isMarketDropdownOpen?: boolean;
  isDropdownOpen?: boolean;
}>();

defineEmits<{
  (e: 'update:activeStep', step: number): void;
}>();
</script>

<template>
  <div class="event-card-parity dark">
    <div class="event-card-header-parity dark">
      <div class="header-info-parity">
        <h3>West Ham - Arsenal</h3>
        <p>Sun 16:30 • Premier League</p>
      </div>
      <div class="header-actions-parity">
        <!-- Desktop Actions -->
        <div class="desktop-header-actions hide-mobile">
          <div class="action-btn-parity static"><Edit3 :size="16" /></div>
          <div class="action-btn-parity" @click="$emit('update:activeStep', 3)"><Plus :size="16" /></div>
          <div class="action-btn-parity static"><X :size="16" /></div>
        </div>
        <!-- Mobile Vertical Dots -->
        <div class="mobile-header-dots hide-desktop">
          <MoreVertical :size="18" class="text-secondary" />
        </div>
        
        <!-- Mobile Menu Simulation -->
        <div v-if="isHeaderMenuOpen" class="mobile-header-menu animate-in hide-desktop">
          <div class="menu-item"><Edit3 :size="14" /> <span>Change Event</span></div>
          <div class="menu-item"><Plus :size="14" /> <span>Add Market</span></div>
          <div class="menu-item danger"><X :size="14" /> <span>Remove Event</span></div>
        </div>
      </div>
    </div>
    
    <div class="event-card-body-parity dark">
      <div class="market-section-parity">
        <div class="market-label-row">
           <span class="market-name">Result</span>
           <X :size="14" class="hide-mobile" />
        </div>
        <div class="market-select-box-parity static dark" :class="{ open: isMarketDropdownOpen }">
           Arsenal <ChevronDown :size="16" />
           
           <div v-if="isMarketDropdownOpen" class="alter-market-dropdown-mock animate-in">
             <div class="dropdown-row active"><Check :size="16" /> Arsenal</div>
             <div class="dropdown-row">West Ham</div>
             <div class="dropdown-row">Draw</div>
           </div>
        </div>
        
        <div class="market-select-box-parity dark" :class="{ open: isDropdownOpen }" @click="$emit('update:activeStep', 1)">
          Full Time <ChevronDown :size="16" />
          
          <div v-if="isDropdownOpen" class="alter-market-dropdown-mock animate-in">
            <div class="dropdown-row active"><Check :size="16" /> Full Time</div>
            <div class="dropdown-row">First Half</div>
            <div class="dropdown-row">Second Half</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.event-card-parity { background: #18181b; border-radius: 16px; border: 1px solid rgba(255,255,255,0.05); overflow: hidden; }
.event-card-header-parity { padding: 16px 24px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid rgba(255,255,255,0.05); }
.header-info-parity h3 { font-size: 1.1rem; font-weight: 800; color: #fff; }
.header-info-parity p { font-size: 0.75rem; color: #71717a; margin-top: 2px; }
.header-actions-parity { display: flex; gap: 16px; position: relative; }
.desktop-header-actions { display: flex; gap: 8px; }
.action-btn-parity { display: flex; align-items: center; gap: 6px; font-size: 0.75rem; font-weight: 700; color: #a1a1aa; padding: 6px 12px; background: #27272a; border-radius: 20px; cursor: pointer; transition: background 0.2s; }
.action-btn-parity.static { cursor: default; }
.action-btn-parity:not(.static):hover { background: #3f3f46; }

.event-card-body-parity { padding: 24px; min-height: 400px; }
.market-section-parity { display: flex; flex-direction: column; gap: 16px; margin-bottom: 24px; min-height: 120px; }
.market-label-row { display: flex; justify-content: space-between; align-items: center; color: #fff; font-weight: 700; }
.market-select-box-parity { background: #000; border: 1px solid #27272a; padding: 12px 16px; border-radius: 10px; display: flex; justify-content: space-between; align-items: center; color: #fff; font-weight: 700; position: relative; cursor: pointer; transition: border-color 0.2s ease; }
.market-select-box-parity.static { cursor: default; }
.market-select-box-parity:not(.static):hover { border-color: #e21b0d; }
.market-select-box-parity.open { border-color: #e21b0d; }

.alter-market-dropdown-mock { position: absolute; top: calc(100% + 8px); left: 0; right: 0; background: #111; border-radius: 10px; border: 1px solid #e21b0d; overflow: hidden; z-index: 100; box-shadow: 0 10px 30px rgba(0,0,0,0.5); }
.dropdown-row { padding: 12px 16px; font-size: 0.9rem; color: #a1a1aa; display: flex; align-items: center; gap: 10px; }
.dropdown-row.active { background: #18181b; color: #fff; font-weight: 700; }

.mobile-header-menu { position: absolute; top: 100%; right: 0; background: #000; border: 1px solid #27272a; border-radius: 12px; width: 180px; z-index: 50; box-shadow: 0 10px 25px rgba(0,0,0,0.5); overflow: hidden; }
.menu-item { padding: 12px 16px; display: flex; align-items: center; gap: 10px; color: #fff; font-size: 0.9rem; font-weight: 700; border-bottom: 1px solid rgba(255,255,255,0.05); }
.menu-item.danger { color: #e21b0d; border-bottom: none; }

@media (max-width: 768px) {
  .event-card-parity { border-radius: 20px; background: #09090b; height: 100%; display: flex; flex-direction: column; }
  .event-card-header-parity { padding: 16px 20px; background: #18181b; }
  .event-card-body-parity { padding: 20px; background: #000; border-radius: 0 0 20px 20px; min-height: auto; flex-grow: 1; }
  .market-section-parity { background: #000; border: 1px solid rgba(255,255,255,0.05); border-radius: 16px; padding: 16px; gap: 12px; min-height: auto; }
  .market-select-box-parity { background: transparent; border: 1.5px solid #27272a; border-radius: 100px; padding: 10px 20px; font-size: 0.95rem; }
  .hide-mobile { display: none !important; }
}

.hide-desktop { display: none; }
@media (max-width: 1024px) {
  .hide-desktop { display: block; }
}

.animate-in { animation: fadeInUp 0.4s ease forwards; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>
